// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageOverview_container__iniXa {
    width: 100%;
    height: 100%;
}

.ImageOverview_header__0isoD {
    width: 100%;
    height: 60px;
}

.ImageOverview_header__crumbs__textDisabled__jht\\+k,
.ImageOverview_header__crumbs__text__PqP8\\+ {
    font-size: 16px;
    line-height: 27px;
    color: #abafb7;
}

.ImageOverview_header__crumbs__text__PqP8\\+ {
    color: #323a45;
}

.ImageOverview_header__crumbs__textDisabled__jht\\+k,
.ImageOverview_header__crumbs__text__PqP8\\+,
.ImageOverview_header__crumbs__icon__GRlve {
    margin-right: 11px;
    -webkit-user-select: none;
            user-select: none;
}

.ImageOverview_section__D5gBQ {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-height: 340px;
}

.ImageOverview_section__left__QgDPR {
    display: flex;
    justify-content: space-between;
    width: 40%;
    height: 100%;
}

.ImageOverview_section__left__minpic__dW4fX {
    width: 73px;
    height: 100%;
}

.ImageOverview_left__img__box__9\\+RIg {
    width: 73px;
    height: 73px;
    border: 2px solid #17a8b5;
    border-radius: 6px;
    cursor: pointer;
}

.ImageOverview_left__img__box__9\\+RIg .ImageOverview_left__img__K0Cqs {
    max-width: 100%;
    max-height: 100%;
    border-radius: 6px;
}

.ImageOverview_section__left__maxpic__5tXGL {
    width: calc(100% - 80px);
    max-height: 340px;
}

.ImageOverview_left__img__K0Cqs {
    max-width: 100%;
    max-height: 100%;
}

.ImageOverview_section__left__maxpic__5tXGL .ImageOverview_left__img__K0Cqs {
    cursor: pointer;
}

.ImageOverview_section__right__q0Deg {
    width: 55%;
    height: 100%;
}

.ImageOverview_right__header__1aNh\\+ {
    font-size: 24px;
    font-weight: bold;
    line-height: 24px;
}

.ImageOverview_right__header__1aNh\\+,
.ImageOverview_right__section__u7oS9 {
    margin-bottom: 10px;
}

.ImageOverview_right__section__u7oS9 {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}

.ImageOverview_right__section__title__eU28D {
    width: 20%;
    font-size: 16px;
    line-height: 24px;
    color: #323a45;
    margin-right: 16px;
}

.ImageOverview_right__section__text__p9qiu {
    width: 80%;
    font-size: 20px;
    font-weight: bold;
    line-height: 30px;
    color: #101417;
}

.ImageOverview_right__section__info__BQ\\+2M {
    width: 80%;
    font-size: 14px;
    line-height: 21px;
    color: #323a45;
}`, "",{"version":3,"sources":["webpack://./src/pages/detail/components/ImageOverview/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB","sourcesContent":[".container {\n    width: 100%;\n    height: 100%;\n}\n\n.header {\n    width: 100%;\n    height: 60px;\n}\n\n.header__crumbs__textDisabled,\n.header__crumbs__text {\n    font-size: 16px;\n    line-height: 27px;\n    color: #abafb7;\n}\n\n.header__crumbs__text {\n    color: #323a45;\n}\n\n.header__crumbs__textDisabled,\n.header__crumbs__text,\n.header__crumbs__icon {\n    margin-right: 11px;\n    user-select: none;\n}\n\n.section {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    max-height: 340px;\n}\n\n.section__left {\n    display: flex;\n    justify-content: space-between;\n    width: 40%;\n    height: 100%;\n}\n\n.section__left__minpic {\n    width: 73px;\n    height: 100%;\n}\n\n.left__img__box {\n    width: 73px;\n    height: 73px;\n    border: 2px solid #17a8b5;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.left__img__box .left__img {\n    max-width: 100%;\n    max-height: 100%;\n    border-radius: 6px;\n}\n\n.section__left__maxpic {\n    width: calc(100% - 80px);\n    max-height: 340px;\n}\n\n.left__img {\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.section__left__maxpic .left__img {\n    cursor: pointer;\n}\n\n.section__right {\n    width: 55%;\n    height: 100%;\n}\n\n.right__header {\n    font-size: 24px;\n    font-weight: bold;\n    line-height: 24px;\n}\n\n.right__header,\n.right__section {\n    margin-bottom: 10px;\n}\n\n.right__section {\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n}\n\n.right__section__title {\n    width: 20%;\n    font-size: 16px;\n    line-height: 24px;\n    color: #323a45;\n    margin-right: 16px;\n}\n\n.right__section__text {\n    width: 80%;\n    font-size: 20px;\n    font-weight: bold;\n    line-height: 30px;\n    color: #101417;\n}\n\n.right__section__info {\n    width: 80%;\n    font-size: 14px;\n    line-height: 21px;\n    color: #323a45;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ImageOverview_container__iniXa`,
	"header": `ImageOverview_header__0isoD`,
	"header__crumbs__textDisabled": `ImageOverview_header__crumbs__textDisabled__jht+k`,
	"header__crumbs__text": `ImageOverview_header__crumbs__text__PqP8+`,
	"header__crumbs__icon": `ImageOverview_header__crumbs__icon__GRlve`,
	"section": `ImageOverview_section__D5gBQ`,
	"section__left": `ImageOverview_section__left__QgDPR`,
	"section__left__minpic": `ImageOverview_section__left__minpic__dW4fX`,
	"left__img__box": `ImageOverview_left__img__box__9+RIg`,
	"left__img": `ImageOverview_left__img__K0Cqs`,
	"section__left__maxpic": `ImageOverview_section__left__maxpic__5tXGL`,
	"section__right": `ImageOverview_section__right__q0Deg`,
	"right__header": `ImageOverview_right__header__1aNh+`,
	"right__section": `ImageOverview_right__section__u7oS9`,
	"right__section__title": `ImageOverview_right__section__title__eU28D`,
	"right__section__text": `ImageOverview_right__section__text__p9qiu`,
	"right__section__info": `ImageOverview_right__section__info__BQ+2M`
};
export default ___CSS_LOADER_EXPORT___;
